import { type FC, useEffect } from "react";
import { type SitecoreContextValue } from "~/foundation/Jss";
import { useEventEmitter } from "~/foundation/Events";
import { type OneTrustEvent } from "./OneTrustEvent";

export function oneTrustHelmetScripts(oneTrustID?: string) {
	if (!oneTrustID) {
		return [];
	}

	return [
		{
			type: "text/javascript",
			src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
			"data-domain-script": oneTrustID,
			"data-document-language": "true",
			async: true,
		},
		{
			type: "text/javascript",
			innerHTML: "function OptanonWrapper() { }",
		},
	];
}

type OneTrustProps = {
	sitecoreContext: SitecoreContextValue
}

let isWaitingForOneTrust = true;

function waitForOneTrust(callback: () => void, timeout = 5000): void {
	if (!isWaitingForOneTrust) {
		callback();
		return;
	}

	const intervalTime = 100;
	let elapsedTime = 0;

	const interval = setInterval(() => {
		if (typeof window.OneTrust?.OnConsentChanged !== 'undefined') {
			clearInterval(interval);
			isWaitingForOneTrust = false;
			callback();
		} else if (elapsedTime >= timeout) {
			clearInterval(interval);
			isWaitingForOneTrust = false;
			console.error('OneTrust was not defined within the timeout period.');
		}

		elapsedTime += intervalTime;
	}, intervalTime);
}

export const OneTrust: FC<OneTrustProps> = () => {
	const eventEmitter = useEventEmitter<OneTrustEvent>("OneTrust");

	useEffect(() => {
		waitForOneTrust(() => {
			window.OneTrust!.OnConsentChanged((e: any) => { // eslint-disable-line
				eventEmitter.emit("onConsentChanged", e);
			})
		}, 5000);
	}, []);

	return null;
}
